// NOTE THIS FILE IS NOT YET READY

import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { BaseComponent, MyClaim, getUrlParams } from 'src/app/shared';
import { OutboundSSO, UserActions } from '../../../shared/models/user';
import { UserActionService } from '../../../shared/services/user-action.service';
import { DisplayService } from '../../services/display-service';
import { Session } from '../../services/session.service';
import { UserRoleService } from '../../services/user-role.service';
import { ConfigurationService } from '../../services/configuration.service';
import { InpageAliasService } from '../../services/inpage-alias.service';
import { LogService } from '../../services/log.service';
import { OutboundSsoService } from '../../services/outbound-sso.service';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { LeaveLinkAccessService } from '../../services/leavelink-access.service';
import { TranslationService } from '../../services/translation.service';
import { Aliases } from '../../models/aliases';

@Component({
  selector: 'app-sidenav',
  template: `
    <div class="app-pt3 app-pb2"></div>

    @if (!hasEulaAgreement) {
      <mat-nav-list>
        @if (!hasEulaAgreement && display.reportClaimSignal()) {
          <a
            mat-list-item
            role="button"
            tabindex="0"
            class="app-mat-list-item"
            routerLinkActive="active-link"
            (click)="reportClaim(drawer)"
            (keydown.enter)="reportClaim(drawer)"
            [routerLinkActiveOptions]="{ exact: true }"
            ><span class="app-mat-list-item-span">{{ reportClaimLabel }}</span></a
          >
        }
        @if (!hasEulaAgreement && display.reportClaimSignal()) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        @if (showLeavelinkSSO) {
          <a
            mat-list-item
            class="app-mat-list-item"
            routerLinkActive
            #rla="routerLinkActive"
            [class.active-link]="rla.isActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [style.text-decoration]="rla.isActive ? 'underline' : null"
            routerLink=""
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="
              tryClose(
                drawer,
                null,
                'Outbound SSO - LEAVELINK',
                'OutboundSSO',
                null
              )
            "
            (keydown.enter)="
              tryClose(
                drawer,
                null,
                'Outbound SSO - LEAVELINK',
                'OutboundSSO',
                null
              )
            "
            ><span class="app-mat-list-item-span">{{
              LeaveLinkText | translation: translationRequest
            }}</span></a
          >
        }
        @if (showLeavelinkSSO) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        @if (session.user.roles.controller) {
          <a
            mat-list-item
            class="app-mat-list-item"
            routerLinkActive
            #rla="routerLinkActive"
            [class.active-link]="rla.isActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [style.text-decoration]="rla.isActive ? 'underline' : null"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="
              tryClose(
                drawer,
                '/controller',
                'Controller View',
                'ControllerView',
                null
              )
            "
            ><span class="app-mat-list-item-span">{{
              'Controller View' | translation: translationRequest
            }}</span></a
          >
        }
        @if (session.user.roles.controller) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        @if (display.summaryViewValidate()) {
          <a
            mat-list-item
            class="app-mat-list-item"
            routerLinkActive
            #rla="routerLinkActive"
            routerLink="/summary"
            [class.active-link]="rla.isActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [style.text-decoration]="rla.isActive ? 'underline' : null"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="
              tryClose(drawer, '/summary', 'Summary View', 'SummaryView', null)
            "
            ><span class="app-mat-list-item-span">{{
              'Summary View' | translation: translationRequest
            }}</span></a
          >
        }
        @if (display.summaryViewValidate()) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        @if (
          this.session.user.roles.supervisor &&
          this.session.user.clientCustomizations.ManagerDashboard
        ) {
          <a
            mat-list-item
            class="app-mat-list-item"
            routerLink="/supervisor"
            routerLinkActive
            #rla="routerLinkActive"
            [class.active-link]="rla.isActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [style.text-decoration]="rla.isActive ? 'underline' : null"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="
              redirectToOwnMgrDashboard();
              tryClose(
                drawer,
                '/supervisor',
                'Manager View',
                'ManagerView',
                null
              )
            "
            ><span class="app-mat-list-item-span">{{
              'Manager View' | translation: translationRequest
            }}</span></a
          >
        }
        @if (this.session.user.roles.supervisor) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        @if (
          isManager &&
          !session.isDelegating() &&
          this.session.user.clientCustomizations.EmployeeDashboard
        ) {
          <a
            mat-list-item
            class="app-mat-list-item"
            [class.active-link]="isOnDashboard()"
            [attr.aria-current]="isOnDashboard() ? 'page' : null"
            [attr.tabindex]="0"
            [style.text-decoration]="isOnDashboard() ? 'underline' : null"
            (click)="redirectToMgrOwnEmpDashboard($event, drawer)"
            (keydown.enter)="redirectToMgrOwnEmpDashboard($event, drawer)"
            ><span class="app-mat-list-item-span">{{
              'My claims' | translation: translationRequest
            }}</span></a
          >
        }
        @if (
          isManager &&
          !session.isDelegating() &&
          this.session.user.clientCustomizations.EmployeeDashboard
        ) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        @if (
          !isManager &&
          !session.isDelegating() &&
          this.session.user.clientCustomizations.EmployeeDashboard
        ) {
          <a
            mat-list-item
            class="app-mat-list-item"
            routerLinkActive
            #rla="routerLinkActive"
            [class.active-link]="rla.isActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [style.text-decoration]="rla.isActive ? 'underline' : null"
            (click)="
              tryClose(drawer, '/dashboard', 'My Claims', 'MyClaims', null)
            "
            (keydown.enter)="
              tryClose(drawer, '/dashboard', 'My Claims', 'MyClaims', null)
            "
            [routerLinkActiveOptions]="{ exact: true }"
            ><span class="app-mat-list-item-span">{{
              'My claims' | translation: translationRequest
            }}</span></a
          >
        }
        @if (
          !isManager &&
          !session.isDelegating() &&
          this.session.user.clientCustomizations.EmployeeDashboard
        ) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        @if (IsMyWorkSchedule && !session.isDelegating()) {
          <a
            mat-list-item
            class="app-mat-list-item"
            routerLinkActive
            #rla="routerLinkActive"
            [class.active-link]="rla.isActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [style.text-decoration]="rla.isActive ? 'underline' : null"
            (click)="
              tryClose(
                drawer,
                '/my-work-schedule',
                'My Work Schedule',
                'MyWorkSchedule',
                null
              )
            "
            [routerLinkActiveOptions]="{ exact: true }"
            ><span class="app-mat-list-item-span">{{
              'My Work Schedule' | translation: translationRequest
            }}</span></a
          >
        }
        @if (IsMyWorkSchedule) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        @if (isIncidentalClient) {
          <a
            mat-list-item
            class="app-mat-list-item"
            routerLinkActive
            routerLink="/absence-dashboard"
            #rla="routerLinkActive"
            [class.active-link]="rla.isActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [style.text-decoration]="rla.isActive ? 'underline' : null"
            (click)="
              tryClose(
                drawer,
                '/absence-dashboard',
                'Absences',
                'Absences',
                null
              )
            "
            [routerLinkActiveOptions]="{ exact: true }"
            ><span class="app-mat-list-item-span">{{
              'Absences' | translation: translationRequest
            }}</span></a
          >
        }
        @if (isIncidentalClient) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        @if (display.commCenter) {
          <a
            mat-list-item
            class="app-mat-list-item"
            routerLink="/communication-center"
            #rla="routerLinkActive"
            routerLinkActive="active-link"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [style.text-decoration]="rla.isActive ? 'underline' : null"
            (click)="
              tryClose(
                drawer,
                '/communication-center',
                'Communication Center',
                'CommunicationCenter',
                null
              )
            "
            title="Communication center"
          >
            <span class="app-mat-list-item-span">{{
              'communication center' | translation: translationRequest
            }}</span>
          </a>
        }
        @if (display.commCenter) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        @if (this.display.search) {
          <a
            mat-list-item
            class="app-mat-list-item"
            routerLinkActive
            #rla="routerLinkActive"
            [class.active-link]="rla.isActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [style.text-decoration]="rla.isActive ? 'underline' : null"
            routerLink="/search"
            (click)="
              tryClose(drawer, '/search', 'Claim Search', 'ClaimSearch', null)
            "
            ><span class="app-mat-list-item-span">{{
              'Claim Search' | translation: translationRequest
            }}</span></a
          >
        }
        @if (this.display.search) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        @if (this.display.watchList && !session.isDelegating()) {
          <a
            mat-list-item
            class="app-mat-list-item"
            routerLink="/watchlist"
            routerLinkActive
            #rla="routerLinkActive"
            [class.active-link]="rla.isActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [style.text-decoration]="rla.isActive ? 'underline' : null"
            (click)="
              tryClose(drawer, '/watchlist', 'Watch List', 'WatchList', null)
            "
          >
            <span class="app-mat-list-item-span">{{
              'Watch List' | translation: translationRequest
            }}</span>
          </a>
        }
        @if (this.display.watchList && !session.isDelegating()) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        @if (this.display.history && !session.isDelegating()) {
          <a
            mat-list-item
            class="app-mat-list-item"
            routerLink="/history"
            routerLinkActive
            #rla="routerLinkActive"
            [class.active-link]="rla.isActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [style.text-decoration]="rla.isActive ? 'underline' : null"
            (click)="tryClose(drawer, '/history', 'History', 'History', null)"
          >
            <span class="app-mat-list-item-span">{{
              'History' | translation: translationRequest
            }}</span>
          </a>
        }
        @if (this.display.history && !session.isDelegating()) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        @if (display.helpPage) {
          <a
            mat-list-item
            class="app-mat-list-item"
            routerLink="/help"
            routerLinkActive
            #rla="routerLinkActive"
            [class.active-link]="rla.isActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [style.text-decoration]="rla.isActive ? 'underline' : null"
            (click)="
              redirectToLearningCenter();
              tryClose(
                drawer,
                'help',
                'Helpful Resources',
                'HelpfulResources',
                {
                  focus: 'learningcenter',
                  origin: 'leftNav',
                }
              )
            "
            ><span class="app-mat-list-item-span">{{
              'Helpful Resources' | translation: translationRequest
            }}</span></a
          >
        }
        @if (display.helpPage) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        @if (!isManager) {
          <a
            mat-list-item
            class="app-mat-list-item"
            (click)="tryClose(drawer, '/design', '', '', null)"
            routerLinkActive
            #rla="routerLinkActive"
            [class.active-link]="rla.isActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [style.text-decoration]="rla.isActive ? 'underline' : null"
            ><span class="app-mat-list-item-span">{{
              'Design' | translation: translationRequest
            }}</span></a
          >
        }
        @if (!isManager) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        @if (actAsDelegate && !session.isDelegating()) {
          <a
            mat-list-item
            class="app-mat-list-item"
            routerLinkActive
            routerLink="/act-as-delegate"
            #rla="routerLinkActive"
            [class.active-link]="rla.isActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [style.text-decoration]="rla.isActive ? 'underline' : null"
            (click)="
              tryClose(
                drawer,
                '/act-as-delegate',
                'Act As Delegate',
                'ActAsDelegate',
                null
              )
            "
            ><span class="app-mat-list-item-span">{{
              'Act as delegate' | translation: translationRequest
            }}</span></a
          >
        }
        @if (actAsDelegate && !session.isDelegating()) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        @if (
          (manageDelegates || manageOthersDelegators) && !session.isDelegating()
        ) {
          <a
            mat-list-item
            class="app-mat-list-item"
            routerLink="/manage-delegates"
            routerLinkActive
            #rla="routerLinkActive"
            [class.active-link]="rla.isActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [style.text-decoration]="rla.isActive ? 'underline' : null"
            (click)="
              tryClose(
                drawer,
                '/manage-delegates',
                'Manage Delegates',
                'ManageDelegates',
                null
              )
            "
            ><span class="app-mat-list-item-span">{{
              'Manage delegates' | translation: translationRequest
            }}</span></a
          >
        }
        @if (
          (manageDelegates || manageOthersDelegators) && !session.isDelegating()
        ) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        @if (!session.isDelegating()) {
          <a
            mat-list-item
            class="app-mat-list-item"
            routerLink="/PreferencesPage"
            routerLinkActive
            #rla="routerLinkActive"
            [class.active-link]="rla.isActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [style.text-decoration]="rla.isActive ? 'underline' : null"
            (click)="
              this.tryClose(
                drawer,
                '/PreferencesPage',
                'Account Settings',
                'AccountSettings',
                null
              )
            "
            role="link"
            ><span class="app-mat-list-item-span">{{
              'Account Settings' | translation: translationRequest
            }}</span></a
          >
        }
        @if (!session.isDelegating()) {
          <mat-divider aria-hidden="true"></mat-divider>
        }
        <a
          mat-list-item
          class="app-mat-list-item"
          [routerLink]="[]"
          (click)="
            logOut(); this.tryClose(drawer, null, 'Logout', 'Logout', null)
          "
          routerLink=""
        >
          <span class="app-mat-list-item-span">{{
            'Log out' | translation: translationRequest
          }}</span>
        </a>
      </mat-nav-list>
    }

    <ng-template #dialogReportNewClaim>
      <app-dialog
        title="Confirmation"
        ariaLabel="Confirmation dialog"
        [width]="700"
        [showActions]="false"
        [showHeader]="false"
        ariaLabelMessage="Close announcement popup"
      >
        <app-report-new-claim></app-report-new-claim>
      </app-dialog>
    </ng-template>
    <ng-template #dialogReportNewClaimList>
      <app-dialog
        title="Confirmation"
        ariaLabel="Confirmation dialog"
        [width]="700"
        [showActions]="false"
        [showHeader]="false"
        ariaLabelMessage="Close announcement popup"
      >
        <app-claim-list-report-absence
          [claims]="this.myClaims"
          [showContinue]="true"
          [redirectToSmartly]="true"
        ></app-claim-list-report-absence>
      </app-dialog>
    </ng-template>
    <ng-template #dialogLogoutConfirmation>
      <app-dialog
        [showHeader]="false"
        ariaLabel="Logout confirmation dialog"
        [width]="700"
        [showActions]="false"
        ariaLabelMessage="Close logout confirmation popup"
      >
        <app-end-claimant-preview></app-end-claimant-preview>
      </app-dialog>
    </ng-template>
  `,
  styles: [
    `
      mat-divider {
        border-top-color: var(--sed-black-60-color) !important;
        margin-left: 20px;
        margin-right: 20px;
      }

      .app-mat-list-item {
        text-align: center;
      }

      .hideSideNav {
        background-color: red;
      }
    `,
  ],
  standalone: false,
})
export class SidenavComponent extends BaseComponent implements OnInit {
  @Input()
  drawer: MatDrawer;

  @Input()
  hasEulaAgreement: any;

  @Input()
  hasReportClaim: any;

  @Input()
  isIncidentalClient: any;

  @Input()
  isManager: any;

  @Input()
  showSearch: any;

  @Input()
  showWatchlist: any;

  @Input()
  showHistory: any;

  @Input()
  actAsDelegate: any;

  @Input()
  manageDelegates: any;

  @Input()
  manageOthersDelegators: any;

  @Input()
  myClaims: MyClaim[];

  @Input()
  isSmall: any;

  @Input()
  isAuditor: any;

  mgrAction: UserActions | null;
  @Input()
  IsMyWorkSchedule: boolean;

  @Input()
  showEmployeeSearch: boolean = true;
  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  @ViewChild('dialogReportNewClaim')
  dialogRefReportNewClaim: TemplateRef<any>;
  @ViewChild('dialogReportNewClaimList')
  dialogRefReportNewClaimList: TemplateRef<any>;
  @ViewChild('dialogLogoutConfirmation')
  dialogRefLogoutConfirmation: TemplateRef<any>;
  isOwnEmpDb = false;
  reportClaimLabel: string = '';
  outboundSSO: OutboundSSO[] = [];
  showLeavelinkSSO: boolean = false;

  get LeaveLinkText(): string {
    if (
      this.outboundSSO != undefined &&
      this.outboundSSO != null &&
      this.outboundSSO.length > 0
    ) {
      const index = this.outboundSSO.findIndex((x) => x.ssoType == 'leavelink');

      if (index > -1) {
        return this.outboundSSO[index].ssoLinkManager;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  constructor(
    public session: Session,
    public dialog: MatDialog,
    public router: Router,
    private userAction: UserActionService,
    public userRole: UserRoleService,
    public display: DisplayService,
    public claimConfigService: ConfigurationService,
    public inpageAliasService: InpageAliasService,
    public logService: LogService,
    public outboundSsoService: OutboundSsoService,
    private leaveLinkAccessService: LeaveLinkAccessService,
    private translationService: TranslationService,
    private aliases: InpageAliasService,
  ) {
    super();
  }

  async ngOnInit() {
    const params = getUrlParams();
    if (!params.emp) {
      this.isOwnEmpDb = true;
    }
    if (this.display.reportClaim) {
      this.reportClaimLabel = await this.aliases.get('ReportClaim');
    }
    this.outboundSSO = this.display.outboundSSO;
    if (
      this.outboundSSO != undefined &&
      this.outboundSSO != null &&
      this.outboundSSO.length > 0
    ) {
      const index = this.outboundSSO.findIndex((x) => x.ssoType == 'leavelink');

      if (index > -1) {
        this.showLeavelinkSSO = this.outboundSSO[index].allowLeftNav;
      } else {
        this.showLeavelinkSSO = false;
      }
    } else {
      this.showLeavelinkSSO = false;
    }
  }

  loadTranslations(): void {
    this.translationService.getTranslation(this.translationRequest);
  }

  tryClose(
    drawer: MatDrawer,
    routerLink: string,
    tabName: string,
    featureName: string,
    queryParams: any,
  ) {
    if (drawer?.mode === 'over') {
      drawer.close();
    }

    if (
      featureName !== null &&
      featureName !== '' &&
      featureName !== undefined
    ) {
      this.FeatureLogging(
        featureName.replaceAll(/\s/g, ''),
        tabName,
        'Navigation',
      );
    }

    if (routerLink !== null && routerLink !== undefined) {
      if (queryParams !== undefined && queryParams !== null) {
        this.router.navigate([routerLink], {
          queryParams,
        });
      } else {
        this.router.navigate([routerLink]);
      }
    } else {
      if (featureName == 'OutboundSSO') {
        if (
          this.outboundSSO != undefined &&
          this.outboundSSO != null &&
          this.outboundSSO.length > 0
        ) {
          const index = this.outboundSSO.findIndex(
            (x) => x.ssoType.toLowerCase() == 'leavelink',
          );
          if (index > -1) {
            this.leaveLinkAccessService.handleLeaveLinkAccess();
          }
        }
      }
    }
  }

  reportClaim(drawer: MatDrawer) {
    if (this.userRole.manager) {
      this.display.mgrAction = this.userAction.getAction();
    }
    if (
      ((this.userRole.manager &&
        (this.display.mgrAction == UserActions.ViewOwnEmpDb ||
          this.display.mgrAction == UserActions.ManagerSummaryView)) ||
        !this.userRole.manager) &&
      this.showReportAbsence() &&
      !this.session.isDelegating() &&
      !this.claimConfigService.getConfigFeatureAccess('leavelinksso')
    ) {
      this.dialog.open(this.dialogRefReportNewClaimList, {
        panelClass: 'claimListDialog',
      });
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        title: 'Confirmation',
      };
      const dlg = this.dialog.open(this.dialogRefReportNewClaim, dialogConfig);
      // this one already has padding
      dlg.updateSize('700px', '380px');
      this.tryClose(drawer, null, 'Report a New Claim', 'ReportClaim', null);
    }
  }

  redirectToLearningCenter() {
    this.userAction.setAction(UserActions.ViewOwnMgrDb);
    this.router.navigate(['help'], {
      queryParams: {
        focus: 'learningcenter',
        origin: 'leftNav',
      },
    });
  }

  isOnDashboard(): boolean {
    return this.router.url === '/dashboard';
  }

  redirectToMgrOwnEmpDashboard(event?: Event, drawer?: MatDrawer) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (drawer?.mode === 'over') {
      drawer.close();
    }

    this.FeatureLogging('MyClaims', 'My Claims', 'Navigation');

    this.userAction.setAction(UserActions.ViewOwnEmpDb);
    window.location.assign('/dashboard');
  }

  redirectToOwnMgrDashboard() {
    this.userAction.setAction(UserActions.ViewOwnMgrDb);
    this.router.navigate(['supervisor'], {});
  }

  showReportAbsence() {
    if (!this.myClaims) {
      return false;
    }
    return (
      this.myClaims.findIndex(
        (claim) =>
          claim.status === 'Open' &&
          claim.lineOfBusiness === 'LV' &&
          claim.claimDescription.toLowerCase().indexOf('intermittent') > -1,
      ) > -1
    );
  }

  async logOut() {
    if (
      this.session.isEmulating$ &&
      this.session.user.emulatorContext != null
    ) {
      this.dialog.open(this.dialogRefLogoutConfirmation);
    } else {
      sessionStorage.removeItem('eulaAccepted');
      await this.session.logoff();
    }
  }
}